import { CreativityContentData, BannerMediaFiles } from '../types/banner';

export const getFirstImage = (creativity: CreativityContentData): string | undefined => {
  return creativity.mediaFiles?.find(r => r.type === 'image')?.url;
};

export const getFirstOptimizedImage = (creativity: CreativityContentData): string | undefined => {
  return creativity.mediaFiles?.find(r => r.type === 'image')?.thumbnail;
};

export const getAllVideos = (creativity: CreativityContentData): BannerMediaFiles[] => {
  return creativity.mediaFiles?.filter(r => r.type === 'video') || [];
};

export const getAllImages = (creativity: CreativityContentData): BannerMediaFiles[] => {
  return creativity.mediaFiles?.filter(r => r.type === 'image' || r.type === 'gif') || [];
};
